import script from "./Goal.vue?vue&type=script&setup=true&lang=ts"
export * from "./Goal.vue?vue&type=script&setup=true&lang=ts"

export default script